const injectTestIframe = () => {
  const ifrm = document.createElement('iframe');
  ifrm.style.display = 'none';
  document.body.appendChild(ifrm);
  ifrm.setAttribute('src', `${CDN_HOST}/check-cookies/complete.html`);
}

export const thirdPartyCookiesEnabled = () => new Promise(resolve => {
  const receiveMessage = evt => {
    if (evt.data === 'MM:3PCunsupported') {
      resolve(false);
    } else if (evt.data === 'MM:3PCsupported') {
      resolve(true);
    }
  };
  window.addEventListener('message', receiveMessage, false);
  try {
    injectTestIframe();
  } catch (e) {
    resolve(false);
  };
});